import { useQueryClient } from '@tanstack/react-query'

import {
  useServiceGroupsServicePostV1IndividualsByIndividualIdServiceGroupsByServiceGroupId,
} from '../client/queries'
import {
  useServiceGroupsServiceGetV1IndividualsByIndividualIdServiceGroupsKey,
} from '../client/queries/common'

export const useGenerateServiceGroupRecommendations = () => {
  const queryClient = useQueryClient()

  return useServiceGroupsServicePostV1IndividualsByIndividualIdServiceGroupsByServiceGroupId({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useServiceGroupsServiceGetV1IndividualsByIndividualIdServiceGroupsKey],
      })
    },
  })
}
